"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fadedOrange = exports.fadedPurple = exports.fadedLightGreen = exports.fadedGreen = exports.fadedBlue = exports.transparent = exports.white = exports.uniqueGrey = exports.black = void 0;
exports.black = '#000000';
exports.uniqueGrey = '#CCCCCC';
exports.white = '#FFFFFF';
exports.transparent = 'transparent';
exports.fadedBlue = '#EAF6FD';
exports.fadedGreen = '#ECF1EF';
exports.fadedLightGreen = '#F2F2E9';
exports.fadedPurple = '#EFE8EE';
exports.fadedOrange = '#F7F3E7';
